import { Navbar } from "../../../components/layout/Navbar";
import { Footer } from "../../../components/layout/Footer";
import { Button } from "../../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { Clock, CheckCircle, Mail } from "lucide-react";
import { useLanguage } from "../../../contexts/LanguageContext";

const WaitingApprovalInvestor = () => {
  const navigate = useNavigate();
  const { language, t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col" dir={language === "ar" ? "rtl" : "ltr"}>
      <Navbar />
      <main className="flex-grow flex items-center justify-center p-4">
        <div className="max-w-2xl w-full bg-card rounded-2xl border border-border p-8 md:p-12 text-center shadow-card">
          <div className="mx-auto w-20 h-20 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mb-6">
            <Clock className="w-10 h-10 text-yellow-600 dark:text-yellow-400" />
          </div>

          <h1 className="text-2xl md:text-3xl font-bold mb-4">{t("waiting.investor.title")}</h1>
          <p className="text-muted-foreground mb-8">
            {t("waiting.investor.message")}
          </p>

          <div className="bg-muted/30 rounded-xl p-6 mb-8 text-left">
            <h2 className="font-semibold mb-3 flex items-center">
              <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
              {t("waiting.investor.whatHappens")}
            </h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start">
                <span className="inline-block w-6 h-6 rounded-full bg-primary/10 text-primary text-xs flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">1</span>
                {t("waiting.investor.reviewPersonal")}
              </li>
              <li className="flex items-start">
                <span className="inline-block w-6 h-6 rounded-full bg-primary/10 text-primary text-xs flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">2</span>
                {t("waiting.investor.verifyCapacity")}
              </li>
              <li className="flex items-start">
                <span className="inline-block w-6 h-6 rounded-full bg-primary/10 text-primary text-xs flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">3</span>
                {t("waiting.investor.confirmPreferences")}
              </li>
              <li className="flex items-start">
                <span className="inline-block w-6 h-6 rounded-full bg-primary/10 text-primary text-xs flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">4</span>
                {t("waiting.investor.notification")}
              </li>
            </ul>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate("/")}
              variant="outline"
              className="gap-2"
            >
              {t("common.backToHome")}
            </Button>
            <Button
              onClick={() => window.location.href = "mailto:support@knowvest.plus"}
              className="gap-2 bg-hero-gradient hover:opacity-90 text-primary-foreground"
            >
              <Mail className="w-4 h-4" />
              {t("common.contactSupport")}
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default WaitingApprovalInvestor;